<template>
    <div class="productLeftBottomTagMain">
        <template v-if="transportationDescriptionList">
            <div
                class="tag"
                v-for="(transportationDescription, index) in transportationDescriptionList"
                :key="index"
            >
                {{ transportationDescription }}
            </div>
        </template>
        <div v-else-if="distance" class="tag">
            次日达
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProductLeftBottomTag',

    props: {
        transportationMode: {
            type: Number || null,
        },

        transportationDescriptionList: {
            type: Array,
        },

        distance: {
            type: Number,
        }
    },
}
</script>

<style lang="scss" scoped>

.productLeftBottomTagMain
{
    position: absolute; 
    left: $margin; 
    bottom: 0px;
    font-size: $fontSizeFootNote;
}

.tag {
    line-height: 2em;
    background: #000000;
    opacity: 0.5;
    color: #ffffff;
    border-radius: $borderRadius;
    margin-bottom: $margin;
    padding: 0 $padding;
}

</style>